// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

let currentURL = window.location.hostname;

 let base_uri = "";

if (currentURL == 'shgbankloan-dev.lokos.in') {

  base_uri = 'https://shgbankloan-dev.lokos.in/api/';

}else if (currentURL == 'shgbankloan.lokos.in') {

  base_uri = 'https://shgbankloan.lokos.in/api/';

 }
else{
  base_uri = 'https://shgbankloan-dev.lokos.in/api/';
}
// let currentURL = window.location.hostname;

//  let base_uri = "https://localhost:9092/"
// let base_uri = "https://192.168.200.126/"
// let base_uri = "http://192.168.200.126:9092/"

export const environment = {
  production: false,
  url: base_uri,
  disableLogs: true,
  currentURL: currentURL // Disable logs for staging
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
